<template>
  <div v-show="showLiveHome">
    <breadcrumbs class="mb-2" v-if="!mobile" />
    <v-row no-gutters>
      <v-col
        cols="12"
        :md="!viewEvent ? 12 : 6"
        v-if="(mobile && !viewEvent) || !mobile"
      >
        <v-card
          class="pb-1 mb-4"
          elevation="0"
          :class="{
            'mr-1': viewEvent,
          }"
          color="colorDominant"
          outlined
        >
          <ToolbarTabSports
            :type="'live'"
            :data="id_sports_live"
            v-on:filterBySports="filterBySports"
          />
          <ToolbarTabMarkets :type="'live'" />
          <v-progress-linear
            absolute
            indeterminate
            :active="loading"
          ></v-progress-linear>
          <Table
            :type="'live'"
            :data="data_events_list_live"
            :dataLive="events_live"
          />
          <div>
            <v-alert
              text
              dense
              v-if="msg_error_alert"
              :type="msg_error === this.$t('loading') ? 'info' : 'warning'"
              border="left"
              class="ma-4 mb-2"
            >
              {{ msg_error }}
            </v-alert>
          </div>
        </v-card>
      </v-col>
      <!-- <v-col v-show="openEvent" :md="$route.query.live ? 12 : 6"> -->
      <v-col cols="12" :md="mobile ? 12 : 6" v-if="viewEvent">
        <div :class="!mobile ? 'ml-2' : ''">
          <v-toolbar dense class="colorDominant my-1" v-if="mobile">
            <div class="d-flex justify-space-between flex-grow-1">
              <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <BottomSheetEvents />
              <GridOrlistOdds />
            </div>
          </v-toolbar>
          <router-view />
        </div>
      </v-col>

      <!-- DESCONTINUADO -->
      <!-- <template v-if="smAndDown">
        <v-dialog
          v-model="dialog"
          scrollable
          transition="fab-transition"
          color="colorDominant"
          content-class="v-dialog--fullscreen"
          :retain-focus="false"
        >
          <v-toolbar absolute dense elevation="0" color="transparent">
            <v-btn
              @click="$router.go(-1)"
              depressed
              fab
              x-small
              style="background-color: rgba(255, 255, 255, 0.2)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <router-view />
        </v-dialog>
      </template> -->
    </v-row>
  </div>
</template>

<script lang="js">

// Utilitary - /util
import websocket from '@/mixins/websocket';

// Components - /components
import Table from '../events/components/table/table'
import ToolbarTabSports from '../events/components/toolbar-sports'
import ToolbarTabMarkets from '../events/components/toolbar-markets'
import breadcrumbs from '@/components/breadcrumbs/breadcrumbs'
import BottomSheetEvents from "@/components/bottom-sheet-events/bottom-sheet-events.vue";
import GridOrlistOdds from "@/components/breadcrumbs/gridOrlistOdds.vue";

export default {
	name: "events",
	mixins: [websocket],
	components: {
		Table,
		ToolbarTabSports,
		ToolbarTabMarkets,
		breadcrumbs,
    BottomSheetEvents,
    GridOrlistOdds
	},
	data: () => {
		return {
			drawer: null,
			msg_error_alert: true,
			msg_error: "",
			events_live: [],
			data_events_list_live: [],
			id_sports_live: [],
			// sport_live: '',
			animate: [],
			loading: true,
      showLiveHome: true,
		};
	},
	created() {
		this.msg_error = this.$t("loading")
	},
	mounted() {
    this.showLiveHome = true;

    const routesNameToGetLiveEvents = [
        "live",
        "Sports",
        "DepositSuccessSports",
        "RegisterSuccessSports",
        "BetSuccessSports",
    ];

		if(routesNameToGetLiveEvents.includes(this.$route.name) || this.$route.query.liveEvent){
			this.getEventsLive();
		}
	},
	beforeDestroy() {
		if(this.connection){
			this.connection.onclose();
		}
	},

	beforeRouteLeave (to, from, next) {  // antes de ir para outra rota ele vai executar abaixo:
	if (this.$route.name === 'live' && this.connection) {
      this.connection.onclose();
      next()
    } else {
      next()
    }
  },

	computed: {
		getIdSport: function () {
			let sportName
			if(this.$route.params.event){
        sportName = this.$route.query.sport;
      } else {
				sportName = this.$route.query.live;
			}
			return this.$store.getters.getIdSportByName(sportName);
		},
		idOperator: function() {
			return Number(this.$store.state.operators.operator_id);
		},
		viewEvent() {
      return this.$route.params.event ? true : false;
    },
    mobile() {
      return this.$vuetify.breakpoint.mobile;
    },
	},

	watch: {
		events_live: function (sports) {
			const id_sports = sports.map(item => item.id);
			const sport     = sports.filter(item => item.id == this.getIdSport);
			this.id_sports_live = sports.map(item => item.id);

			// Caso não exista dado de deternimado ao vivo ele redireciona para o próximo
			if(sport[0] != undefined) {
				this.data_events_list_live =	sport[0].categories
			} else {
				this.$router.push({
					query: {
						sport: this.$route.query.sport,
						live: this.$store.getters.getNameSportById(id_sports[0]),
					}
				})
			}
		},

		"$route.query.live": function() {
			this.data_events_list_live = this.events_live.filter( item => item.id == this.getIdSport)[0].categories
		},

		// Para a troca de rotas após o primeiro acesso:
		// $route(){
		// 	// Condicionais:
		// }

	},

	methods: {
		getEventsLive: function () {
			this.loading = true;
      this.showLiveHome = true;
			this.$axios.post('/tableMain/liveEvents ', this.$formdata({
					domain: this.$domain(),
					main: this.$route.name === "Sports" ? 1 : 0
				})).then(resp => {
				const { sports } = resp.data
				let wsUrl = this.$route.name === 'Sports' ? 'wss://wsh.sga.bet' : this.$permissions().currentWs
				this.events_live = sports;
				// console.log("eventsLive",  this.events_live)
				this.connect(this.idOperator, null, wsUrl);
				this.msg_error_alert = false; // reset
			}).catch(error => {
				this.msg_error = error.response.data.messages.error;
        if(error.response.data.status == 400 && this.$route.name === 'Sports'){
          this.showLiveHome = false;
        }
			}).finally(()=>{this.loading = false;})
		},

		// Emit - Run only when nextEvents
		filterBySports: function (sport) {
			this.data_events_live = []
			this.data_events_live = this.events_live.filter(item => item.id == sport.id)[0].categories
		},
	},
};
</script>
